import googleTableParser from "./googleTableParser";

export default function () {
    let electionWidgetPlace = document.getElementById('result-city-list');

    if (electionWidgetPlace === null || electionWidgetPlace.classList.contains('inited')) {
        return;
    }

    let opt = {};

    if (!window.location.pathname.includes('/ru/')) {
        opt.cityMayor = 'МЕР МІСТА';
        opt.regionConsignment = 'ПАРТІЯ (ОБЛАСТЬ)';
        opt.cityConsignment = 'ПАРТІЯ (МІСТО)';
        opt.moreDetails = 'детальніше';
        opt.hide = 'приховати';
    } else {
        opt.cityMayor = 'МЭР ГОРОДА';
        opt.regionConsignment = 'ПАРТИЯ (ОБЛАСТЬ)';
        opt.cityConsignment = 'ПАРТИЯ (ГОРОД)';
        opt.moreDetails = 'детальнее';
        opt.hide = 'спрятать';
    }

    let urlToTable = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vTUYq1JJLwus1D97NQd_b8ul-B9lVhccjQONO3qF0xQr-KFzG_MaXxN7KkThaBHIpVbLcpY1xP4FH6r/pubhtml#';

    let allCitiesData = googleTableParser(urlToTable);
    let cities = Object.keys(allCitiesData)

    for (let i = 0; i < cities.length; i++) {
        renderTable(i, allCitiesData[cities[i]], cities[i]);
    }

    function renderTable(index, allCitiesData, city) {
        renderCity(city, index);
        renderCandidates(index, allCitiesData);
        renderShowMore(index);
        addListeners(index);
    }

    function renderCity(city, index) {
        let cityWrapper = document.createElement('div');
        cityWrapper.classList.add('city-item')

        cityWrapper.innerHTML =
            '<div class="city-name">\n' +
            ''+ city +'\n' +
            '</div>'

        cityWrapper.innerHTML +=
            '<div class="results" id="results-'+index+'">\n' +
            '' +
            '</div>'

        document.getElementById('result-city-list').appendChild(cityWrapper);
    }

    function renderCandidates(index, allCitiesData) {
        let leader = allCitiesData[0][0];
        let leaderIndex = 0;

        for (let i = 0; i < 3; i++) {
            if (parseInt(leader[1], 10) < parseInt(allCitiesData[i][0][1], 10)) {
                leader = allCitiesData[i][0];
                leaderIndex = i;
            }
        }

        for (let j = 0; j < 3; j++) {
            let candidateType;
            let candidateClass;

            if (j === 0) {
                candidateClass = 'city-mayor';
                candidateType = opt.cityMayor + ':';
            } else if (j === 1) {
                candidateClass = 'region-party';
                candidateType = opt.regionConsignment + ':';
            } else {
                candidateClass = 'city-party';
                candidateType = opt.cityConsignment + ':';
            }

            let resultsWrapper = document.createElement('div');
            resultsWrapper.classList.add(candidateClass);
            resultsWrapper.classList.add('result-type');
            resultsWrapper.id = candidateClass + '-' + index;
            resultsWrapper.innerHTML = '<p>' + candidateType + '</p>'

            document.getElementById('results-'+index).appendChild(resultsWrapper);
            for (let i = 0; i < allCitiesData[0].length; i++) {
                let candidate = document.createElement('div');
                let candidatePosition = document.createElement('div');
                let candidateStatistics = document.createElement('div');
                let candidateInterest = document.createElement('div');
                let candidateName = document.createElement('div');
                let votesNumber = document.createElement('div');
                let votesWrapper = document.createElement('div');

                candidateName.classList.add('candidate-name')
                candidateName.innerText = allCitiesData[j][i][0]

                votesWrapper.classList.add('votes-number');
                if (leaderIndex === j && i === 0) {
                    votesWrapper.classList.add('winner');
                } else if (i!== 0) {
                    votesWrapper.classList.add('looser');
                }
                votesWrapper.style.width = allCitiesData[j][i][1] + '%';

                votesNumber.classList.add('statistic')
                votesNumber.appendChild(votesWrapper);

                candidate.classList.add('candidate-item');

                candidatePosition.classList.add('position');
                candidatePosition.innerText = i + 1;

                candidateStatistics.classList.add('candidate-statistic');
                candidateStatistics.appendChild(candidateName);
                candidateStatistics.appendChild(votesNumber);

                candidateInterest.classList.add('candidate-interest');
                candidateInterest.innerText = allCitiesData[j][i][1] + '%';

                candidate.appendChild(candidatePosition);
                candidate.appendChild(candidateStatistics);
                candidate.appendChild(candidateInterest);

                document.getElementById(candidateClass + '-' + index).appendChild(candidate);
            }
        }
    }

    function renderShowMore(index) {
        let showMoreWrapper = document.createElement('div');
        showMoreWrapper.classList.add('show-all');
        showMoreWrapper.innerHTML =
            '    ' + opt.moreDetails + '\n' +
            '    <span>' + opt.hide + '</span>\n' +
            '    <span class="image"></span>'

        document.getElementById('results-'+index).appendChild(showMoreWrapper);
    }

    function addListeners(index) {
        let showMoreButton = $('#results-' + index + ' > div.show-all');
        showMoreButton.on('click', function () {
            $('#results-' + index).children('.result-type').toggleClass('active');
            $('#results-' + index + ' > div.show-all').toggleClass('active');
        });

        electionWidgetPlace.classList.add('inited');
    }
}